module.exports = __webpack_public_path__ + "static/media/dictationdone.e0ab9125.mp3";